import { useMemo } from 'react';

import { TOKEN_SCOPE, useServiceAppState } from '@kc-console/context';
import { getConsoleBaseUrl, useTranslation } from '@kc-console/core';

import ExternalLinkButton from './ExternalLinkButton';

/**
 * 내 역할 보기 링크 버튼 컴포넌트
 * @description
 * - 현재 내가 보유하고 있는 권한을 확인할 수 있는 페이지로 이동합니다.
 * - scope 을 확인하여 프로젝트 또는 도메인 권한 확인 링크로 이동합니다.
 * @example
 * // 권한 확인이 필요한 페이지에서 사용
 * <MyRoleGuideLinkButton />
 */
export default function MyRoleGuideLinkButton() {
  const {
    state: { scope },
  } = useServiceAppState();
  const { t } = useTranslation();
  const myRoleGuideURL = useMemo(() => {
    const baseUrl = getConsoleBaseUrl();
    if (scope === TOKEN_SCOPE.PROJECT) {
      return `${baseUrl}/settings/project-roles`;
    }
    return `${baseUrl}/settings/domain-roles`;
  }, [scope]);

  return (
    <ExternalLinkButton title={t('layout:service.expection.my_role_info')} url={myRoleGuideURL} />
  );
}
